// @ts-check
import { createClient } from 'urql';
const sanityGraphqlUri = `https://${process.env.GATSBY_SANITY_PROJECT_ID}.api.sanity.io/v1/graphql/production/default`;
const client = createClient({
  url: sanityGraphqlUri,
  requestPolicy: 'cache-and-network',
  fetchOptions: () => {
    return {
      credentials: 'include',
      mode: 'cors',
    };
  },
});
export default client;
